import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PlayerRosterStatsDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra la Plantilla (Roster)
 * de un equipo para una temporada, con sus estadísticas agregadas.
 */
@Component({
  selector: 'app-team-roster-stats',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatCardModule,
    MatTableModule,
    MatIconModule
  ],
  templateUrl: './team-roster-stats.component.html',
  styleUrls: ['./team-roster-stats.component.scss']
})
export class TeamRosterStatsComponent {

  /**
   * La lista de jugadores y sus estadísticas de temporada.
   */
  @Input({ required: true }) roster!: PlayerRosterStatsDTO[] | null;

  /**
   * Columnas a mostrar en la tabla de estadísticas.
   */
  public displayedColumns: string[] = [
    'playerName',
    'matches',
    'goals',
    'exclusions'
  ];

}
